import { createSlice } from '@reduxjs/toolkit';

const groupInfoSlice = createSlice({
  name: 'groupInfo',
  initialState: {
    // @type {[groupId] : slideBannerInfo[] }
    sliderBanner: {},
    games: {},
    refLinks: {},
    refLinksInfo: {},
    postback: {}
  },
  reducers: {
    setRefLinks: (state, action) => {
      const { data, groupId } = action.payload;
      state.refLinks[groupId] = data;
    },
    setRefLinksInfo: (state, action) => {
      const { data, groupId } = action.payload;
      state.refLinksInfo[groupId] = data;
    },
    setSliderBanner: (state, action) => {
      state.sliderBanner = action.payload;
    },
    setSliderBannerGroup: (state, action) => {
      const { data, groupId } = action.payload;
      state.sliderBanner[groupId] = data;
    },
    setPostback: (state, action) => {
      const { data, groupId } = action.payload;
      state.postback[groupId] = data;
    }
  }
});

export default groupInfoSlice.reducer;

export const { setSliderBanner, setSliderBannerGroup, setRefLinks, setRefLinksInfo, setPostback } =
  groupInfoSlice.actions;
